import React from "react";

const RegNumberDetails = ({ caseDetails, leftPosition, topPosition }) => {
  return (
    <div
      className="details_tooltip_wrapper car-details-tooltip"
      style={{ left: leftPosition, top: topPosition }}
    >
      <div className="x_panel">
        <div className="x_title">
          <h2>Car Details</h2>
          <div className="clearfix"></div>
        </div>
        <div className="x_content">
          <div className="row">
            <div className="col-md-4 col-sm-3">
              <div className="form-group">
                <label className="label_text">Make</label>
                <div className="casedetailTxt clearfix" title="">
                  <span className="hiddenText">
                    {caseDetails.make !== "" ? caseDetails.make : "--"}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-3">
              <div className="form-group">
                <label className="label_text">Model</label>
                <div className="casedetailTxt clearfix" title="">
                  <span className="hiddenText">
                    {caseDetails.model !== "" ? caseDetails.model : "--"}
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-3">
              <div className="form-group">
                <label className="label_text">Manuf. Year</label>
                <div className="casedetailTxt clearfix">
                  {caseDetails.myear !== "" ? caseDetails.myear : "--"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegNumberDetails;
